module.exports = __webpack_public_path__ + "img/sliders-02.88e60792.jpg";